/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompleteOnboardingStepRequest } from '../../models/complete-onboarding-step-request';
import { OnboardingStateDto } from '../../models/onboarding-state-dto';

export interface OnboardingCompleteStepPost$Json$Params {
      body?: CompleteOnboardingStepRequest
}

export function onboardingCompleteStepPost$Json(http: HttpClient, rootUrl: string, params?: OnboardingCompleteStepPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OnboardingStateDto>> {
  const rb = new RequestBuilder(rootUrl, onboardingCompleteStepPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OnboardingStateDto>;
    })
  );
}

onboardingCompleteStepPost$Json.PATH = '/onboarding/complete-step';
